module.exports = __webpack_public_path__ + "media/images/icons/icn_007-f7618fa6df453710fa2eaf72a467b813.svg";